export enum PRODUCT_LINE_IDS {
  WYSIWYG_PRODUCT_LINE_ID = 1,
  VIVIEN_PRODUCT_LINE_ID = 2,
}
